module.exports = __webpack_public_path__ + "static/yt_3@2x-d059d5444578f9e45ae366bcc613207f.jpg";